import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import Checkbox from '@mui/material/Checkbox';

import OrderTransferDetailsView from './components/OrderTransferDetails';

const OrderTransferDetailsIndex = () => {
  useEffect(() => {
    getAllRoles();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [isTitle, setTitle] = useState(null);
  const [isRedirect, setRedirect] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(0);

  const handleCheckboxClick = (id) => {
    const selectedIndex = selectedItems.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selectedItems, id];
    } else {
      newSelected = selectedItems.filter((item) => item !== id);
    }

    setSelectedItems(newSelected);
  };

  const selectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = reactTableData.map((item) => item.id);
      setSelectedItems(newSelecteds);
      return;
    }
    setSelectedItems([]);
  };
  const getAllRoles = async () => {

    // const response = await umsApis.roleApi.findAllRoles();
    // if (response.status === 200) {
    // setReactTableDataRoles({ tableHeaderData: columns, tableRowsData: response.data.data });
    //setReactTableDataRoles({ tableHeaderData: columns, tableRowsData: null }); 
    setReactTableData({ tableHeaderData: columns, tableRowsData: null });
    // }
  };



  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 65,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        id: 'select',
        Header: (row) => (
          <div>
            <span>Select</span>
            <Checkbox checked={selectedItem > 0 ? true : false} onClick={() => selectAll(row)} />
          </div>
        ),

        accessor: "checkbox",
        disableSortBy: true,
        width: 15,

        Cell: ({ row }) => (
          <div>
            <Checkbox
              onClick={(event) =>
                handleCheckboxClick(event, row.id, row)
              }
              checked={row.original.checkbox}
            />
          </div>
        )
      },
      {
        Header: 'Tracking No.',
        accessor: 'emirates',
        disableGlobalFilter: false,
      },
      {
        Header: 'Invoice No.',
        accessor: 'emiratesName',
        disableGlobalFilter: false,
      },

      {
        Header: 'Assigned Rider Name',
        accessor: 'riderName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Order Date Time',
        accessor: 'orderDate',
        disableGlobalFilter: false,
      },
      {
        Header: 'Order Requested Date Time',
        accessor: 'orderRequestDate',
        disableGlobalFilter: false,
      },
      {
        Header: 'Dlv Location',
        accessor: 'dlvLocation',
        disableGlobalFilter: false,
      },
      {
        Header: "Order Status",
        accessor: "status",
      },


    ],
    [],
  );

  return (
    <Container>
      <OrderTransferDetailsView reactTableData={reactTableData} isRedirect={isRedirect} setRedirect={setRedirect} isTitle={isTitle} setTitle={setTitle} handleCheckboxClick={handleCheckboxClick}
        selectAll={selectAll} />
    </Container>
  );
};

export default OrderTransferDetailsIndex;